import customDownloadOptions from '@assets/css/custom-download-options.css';

/**
 * Custom download options styles.
 * @type {CSSStyleSheet}
 */
export const customDownloadOptionsStyles = new CSSStyleSheet();
customDownloadOptionsStyles.replaceSync(customDownloadOptions);
